/* __next_internal_client_entry_do_not_use__ EagerlyRenderCategoryRoutes auto */ import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedInCategoryPageBase } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LoggedInCategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SDUICategoryPageBase } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/SDUICategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedInCategoryPageBaseProvider } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/LazyLoggedInCategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SDUICategoryPageBaseProvider } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/LazySDUICategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedOutCategoryPage } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/LoggedOutCategoryPage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedOutCategoryPageProvider } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/LazyLoggedOutCategoryPage";
import { CategoryRouter } from "@faire/retailer-visitor-shared/views/category/CategoryRouter";
import { Route as UnknownRoute } from "@faire/web--source/ui/routing/Route";
import React from "react";
export var EagerlyRenderCategoryRoutes = function() {
    return /*#__PURE__*/ _jsx(UnknownRoute, {
        path: "/category",
        component: CategoryRouterWithEagerlyLoadedRenderers
    });
};
var CategoryRouterWithEagerlyLoadedRenderers = function() {
    return /*#__PURE__*/ _jsx(LoggedOutCategoryPageProvider, {
        value: LoggedOutCategoryPage,
        children: /*#__PURE__*/ _jsx(SDUICategoryPageBaseProvider, {
            value: SDUICategoryPageBase,
            children: /*#__PURE__*/ _jsx(LoggedInCategoryPageBaseProvider, {
                value: LoggedInCategoryPageBase,
                children: /*#__PURE__*/ _jsx(CategoryRouter, {})
            })
        })
    });
};
